<template>
<div>
    <button @click.prevent="deliver" class="font-bold text-primary px-1" title="Deliver Once"><font-awesome-icon :icon="['fas', 'paper-plane']" class="mr-1"></font-awesome-icon><span class="hidden md:inline">Deliver Once</span></button>
</div>
</template>

<script>
export default {
    props: {
        message: {
            type: Object,
            required: true,
        }
    },
    methods: {
        deliver(action) {
            axios.post('/api/messages/' + this.message.id + '/deliveries')
            .then(err => {
                this.$emit('inspected', {
                    'action': 'once',
                });
            }).catch(err => console.log(err));
        }
    }
}
</script>